module.exports = function getResource(label, vars = []) {
    const resources = {
        applyRougeRewards: 'Appliquer des récompenses Rouge',
        rougeReward: `${vars[0]} $ en récompenses Rouge`,
        expires: `*${vars[0]} $ de réduction* • Exp. : ${vars[1]}`,
        expiresDate: `Expiration ${vars[0]}`,
        applied: `${vars[0]} $* de réduction appliqué`,
        switchToUS: 'La récompense Rouge ne peut être utilisée que dans le pays où la récompense a été échangée. Veuillez passer à notre expérience de magasinage aux États-Unis pour utiliser cette récompense.',
        switchToCA: 'La récompense Rouge ne peut être utilisée que dans le pays où la récompense a été échangée. Veuillez passer à notre expérience de magasinage au Canada pour utiliser cette récompense.'
    };

    return resources[label];
};
